import { useState, useEffect, useRef } from 'react'
import { array, func } from 'prop-types'

import useDirectUpload from 'Utils/useDirectUpload'

function DirectUploadFiles({
  files = [],
  onUploadProgress = () => {},
  onUploadStart = () => {},
  finalizeUpload = () => {},
}) {
  const [filesCount, setFilesCount] = useState(0)
  const [filesToUpload, setFilesToUpload] = useState([])
  const [isUploading,, directUpload] = useDirectUpload()
  // Ref-based dedup: React 18's automatic batching can cause the effect below
  // to re-fire before state updates commit, bypassing state-based checks.
  // A ref is mutated synchronously so the second invocation always sees it.
  const uploadedNamesRef = useRef(new Set())

  useEffect(() => {
    if (!isUploading && filesCount <= 0) {
      clearData()
    }
  }, [filesCount])

  useEffect(() => {
    if (files.length > 0) {
      const filesArray = Array.from(files)
      const newFilesToUpload = filesArray.filter(
        ({ name }) => !uploadedNamesRef.current.has(name)
      )

      if (newFilesToUpload.length > 0) {
        newFilesToUpload.forEach(({ name }) => uploadedNamesRef.current.add(name))
        setFilesCount(prev => prev + newFilesToUpload.length)
        setFilesToUpload(prev => [...prev, ...newFilesToUpload])
        newFilesToUpload.forEach(file => upload(file))
        onUploadStart()
      }
    }
  }, [files])

  function upload(file) {
    directUpload(file, {
      onProgress: (progress) => onUploadProgress(file.name, progress),
      onCompleted: (blobId) => {
        finalizeUpload(blobId)
        setFilesCount(prev => prev - 1)
      },
    })
  }

  function clearData() {
    setFilesCount(0)
    setFilesToUpload([])
    uploadedNamesRef.current.clear()
  }

  return null
}

DirectUploadFiles.propTypes = {
  files: array,
  onUploadStart: func,
  finalizeUpload: func,
  onUploadProgress: func,
}

export default DirectUploadFiles
